import { render, staticRenderFns } from "./ItemWithDifferentPrices.vue?vue&type=template&id=991bbefe&scoped=true"
import script from "./ItemWithDifferentPrices.vue?vue&type=script&lang=js"
export * from "./ItemWithDifferentPrices.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "991bbefe",
  null
  
)

export default component.exports